import utils from 'analytics/utils';
import anaConsts from 'analytics/constants';
import deepExtend from 'utils/deepExtend';

export default function () {
    const currentEvent = utils.getMostRecentEvent(anaConsts.LINK_TRACKING_EVENT);
    const newProductString = (currentEvent.eventInfo.attributes.productStrings += '|eVar72=' + anaConsts.PAGE_TYPES.USER_PROFILE);
    const internalCampaign = anaConsts.CAMPAIGN_STRINGS.ADD_FLASH_TO_BASKET;

    deepExtend(currentEvent, {
        eventInfo: {
            attributes: {
                productStrings: newProductString,
                actionInfo: internalCampaign,
                internalCampaign: internalCampaign
            }
        }
    });
}
